import { useAppSelector } from './useAppSelector';

export const useImposter = () => useAppSelector(({ imposter }) => imposter);
